import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import * as Sentry from "@sentry/react";
import { initGA } from "@/analytics";

initGA();

Sentry.init({
  dsn: "https://fb720d04b930410f9fa4df372ec899e1@o4509088072728576.ingest.us.sentry.io/4509088077643776",
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 0.5,
  tracePropagationTargets: [
    "localhost",
    "weu.kr",
    "apireview_dev.unnispick.com",
    "apireview.unnispick.com",
    "project_review_dev.unnispick.com",
  ],
});

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(<App />);
